// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"d94b0ba4","93":"040b4813","527":"ed2a5aaa","787":"d4aba7ab","792":"d65651a9"}[chunkId] + ".chunk.js";
};